import { createContext } from 'react';

export type PaymentContextValue = {
  backLink:
    | string
    | {
        pathname: string;
        search: string;
      };
};

export const PaymentContext = createContext<PaymentContextValue>({
  backLink: '',
});
